import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Clock, Users, Award } from 'lucide-react';

export const CTA = ({ onApplyClick }) => {
  const ctaBackground = "https://images.unsplash.com/photo-1490133961212-53d0e60a1f73";
  
  return (
    <section
      className="cta-section-bg section-padding container-padding"
      style={{ backgroundImage: `url(${ctaBackground})` }}
    >
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in-up">
          Your Wellness Industry Authority Starts Here
        </h2>
        
        <p className="text-xl md:text-2xl text-gray-100 mb-8 animate-fade-in-up stagger-1">
          Join the exclusive cohort of 60 future wellness industry leaders. Applications reviewed on a rolling basis.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-10 animate-fade-in-up stagger-2">
          <div className="flex items-center gap-3 text-white bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
            <Clock className="w-5 h-5" />
            <span className="font-semibold">12 Months</span>
          </div>
          <div className="flex items-center gap-3 text-white bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
            <Users className="w-5 h-5" />
            <span className="font-semibold">60 Seats Only</span>
          </div>
          <div className="flex items-center gap-3 text-white bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
            <Award className="w-5 h-5" />
            <span className="font-semibold">100% Scholarship</span>
          </div>
        </div>

        <Button
          size="lg"
          className="bg-white text-purple-700 hover:bg-gray-100 btn-transition text-xl px-12 py-7 font-bold focus-ring animate-fade-in-up stagger-3"
          onClick={onApplyClick}
        >
          Apply Now
          <ArrowRight className="ml-2 w-6 h-6" />
        </Button>

        <p className="text-gray-200 mt-6 animate-fade-in-up stagger-4">
          Selection-based admission • Applications close when seats fill
        </p>
      </div>
    </section>
  );
};
